import React, { useState } from "react";
import { Icon } from "@iconify/react";
import "../styles/edit-profile-sidebar.css";
import actvtyImg from "../../../assets/user-img-placeholder.jpg";

function EditProfileSidebar({ activeComponent, setActiveComponent, userInfo }) {
  const list = [
    {
      id: 1,
      title: "Supplier type",
      icon: "mage:user",
    },
    {
      id: 2,
      title: "Business details",
      icon: "lucide:calendar-check",
    },
    {
      id: 3,
      title: "Experience offered",
      icon: "hugeicons:notification-02",
    },
    {
      id: 4,
      title: "Personal details",
      icon: "ep:lock",
    },
    {
      id: 5,
      title: "Account details",
      icon: "mingcute:bank-line",
    },
  ];
  return (
    <div className="usr-p-sbar card bg-white pb-3">
      {/* User Image */}
      <div className="usr-p-sbar-img-container text-center py-4">
        <img
          src={
            userInfo?.supplier?.supplier_company_logo
              ? userInfo?.supplier?.supplier_company_logo
              : actvtyImg
          } // Replace with actual image path
          alt="User"
          className="usr-p-sbar-img rounded-circle"
          width={100}
          height={100}
        />
        <h1 className="usr-p-sbar-name mt-3">
          {userInfo?.supplier_user_full_name
            ? `${userInfo.supplier_user_full_name}`
            : userInfo?.supplier_user_email}
        </h1>
      </div>

      {/* Menu Items */}
      <div className="usr-p-sbar-menu ">
        {list.map((item, index) => {
          return (
            <div
              key={index}
              onClick={() => {
                setActiveComponent(item.id);
                localStorage.setItem("DODEditProfileActiveComponent", item.id);
              }}
              className={`usr-p-sbar-link  ${
                item.id === activeComponent && "active"
              } `}
            >
              <Icon icon={item.icon} className="me-2" width={25} height={25} />
              <h3>{item.title}</h3>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default EditProfileSidebar;
  